import CollectionFollowButton from "./collection-follow-button";

export default CollectionFollowButton;